<template>
<BootstrapDialog title="培训项目详情" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div style="width: 100%;padding:10px">
			<table width="100%" class="table xunw_table_form" border="0">
				<tbody>
					<tr>
						<th width="15%" align="right">培训项目编号</th>
						<td width="35%">{{model.xmbh}}</td>
						<th width="15%" align="right">培训项目名称</th>
						<td width="35%">{{model.pxzt}}</td>
					</tr>
					<tr>
						<th align="right">项目分类</th>
						<td colspan="3">{{model.lxmc}}</td>
					</tr>
					<tr>
						<th align="right">培训对象</th>
						<td colspan="3">{{model.pxdx}}</td>
					</tr>
					<tr>
						<th  align="right">培训开始时间</th>
						<td>{{model.pxkssj.substring(0, 16)}}</td>
						<th  align="right">培训结束时间</th>
						<td>{{model.pxjssj.substring(0, 16)}}</td>
					</tr>
					<tr>
						<th align="right">集体报名开始时间</th>
						<td>{{model.jtbmkssj.substring(0, 16)}}</td>
						<th align="right">集体报名结束时间</th>
						<td>{{model.jtbmjssj.substring(0, 16)}}</td>
					</tr>
					<tr>
						<th align="right">是否开放个人报名</th>
						<td colspan="3">{{model.sfyxgrbm == 1 ? '是' : '否' }}</td>
					</tr>
					<tr v-if="model.sfyxgrbm == 1">
						<th align="right">个人报名开始时间</th>
						<td>{{model.grbmkssj.substring(0, 16)}}</td>
						<th align="right">个人报名结束时间</th>
						<td>{{model.grbmjssj.substring(0, 16)}}</td>
					</tr>
					<tr>
						<th align="right">视频学习结束时间</th>
						<td colspan="3">{{model.spxxjssj.substring(0, 16)}}</td>
					</tr>
					<tr>
						<th align="right">是否开放课件学习弹题</th>
						<td >{{model.kftt == 1 ? '是' : '否'}}</td>
						<th align="right">状态</th>
						<td v-html="model.zt=='OK'?'启用':model.zt=='BLOCK'?'禁用':''"></td>
					</tr>
					<tr>
						<th align="right">是否开启抓拍</th>
						<td >{{model.sfkqsxt == 1 ? '是' : '否'}}</td>
						<th align="right">是否开启人脸比对</th>
						<td >{{model.sfkqrlbd == 1 ? '是' : '否'}}</td>
					</tr>
					<tr>
						<th align="right">培训费用</th>
						<td colspan="3">{{model.pxfy}}(元)</td>
					</tr>
				</tbody>
			</table>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>
	/**
	 * 培训批次设置-培训批次详情
	 */
	export default {
		name: "TrainingBatchConfigDetail",
		components:{
		},
		data: function() {
			return {
				model: {
					id: '',
					xmbh: '',
					pxzt: '', //培训主题
					pxkssj: '',
					pxjssj: '',
					lxId: null,
					pxdx: '',
					jtbmkssj: '', //集体报名开始时间
					jtbmjssj: '', //集体报名结束时间
					state: '', //是否开放个人报名
					grbmkssj: '', //个人报名开始时间
					grbmjssj: '', //个人报名结束时间
					spxxjssj: '', //视频学习结束时间
					kftt: '', //是否开放弹题
					zt: '', //状态
					pxfy: '',
					//	新增
                    sfkqrlbd:'',
                    sfkqsxt:''
				}
			}
		},
		methods: {
			reset:function(){
				this.model = {
					id: '',
					xmbh: '',
					pxzt: '', //培训主题
					pxkssj: '',
					pxjssj: '',
					lxId: null,
					pxdx: '',
					jtbmkssj: '', //集体报名开始时间
					jtbmjssj: '', //集体报名结束时间
					state: '', //是否开放个人报名
					grbmkssj: '', //个人报名开始时间
					grbmjssj: '', //个人报名结束时间
					spxxjssj: '', //视频学习结束时间
					kftt: '', //是否开放弹题
					zt: '', //状态
					pxfy: '',
					//	新增
				    sfkqrlbd:'',
				    sfkqsxt:''
				}
			},
			async open(params){
				let id = params.id;
				let res =await this.$http.post('/htgl/biz/pxjh/pc/xq', {
					id: id
				});
				if(res.data){
					this.model = res.data;
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			}
		}
	}
</script>
